(() => {
  function init(root) {
    if (root.dataset.ready) return;
    root.dataset.ready = 'true';
    const $ = s => root.querySelector(s), $$ = s => [...root.querySelectorAll(s)];
    const reduced = matchMedia('(prefers-reduced-motion: reduce)');
    const behavior = () => reduced.matches ? 'instant' : 'smooth';
    const form = $('.apparelForm'), select = $('[data-variant-select]');
    const variants = JSON.parse($('[data-variants]').textContent);
    const options = $$('[data-option]').sort((a,b) => Number(a.dataset.option) - Number(b.dataset.option));
    let selected = variants.find(v => String(v.id) === select.value);
    let choices = options.map((o,i) => selected?.options[i] ?? (o.querySelectorAll('[data-option-value]').length === 1 ? o.querySelector('[data-option-value]').dataset.optionValue : null));
    const quantity = form.querySelector('[name="quantity"]'), add = $('[data-add]');
    function updateOptions() {
      selected = variants.find(v => v.options.every((value,i) => value === choices[i]));
      select.value = selected ? selected.id : '';
      options.forEach((o,i) => {
        o.querySelector('[data-option-label]').textContent = choices[i] || 'Select an option';
        o.querySelectorAll('[data-option-value]').forEach(b => {
          const value = b.dataset.optionValue;
          b.disabled = !variants.some(v => v.available && v.options[i] === value && v.options.every((x,j) => j === i || !choices[j] || x === choices[j]));
          b.classList.toggle('selectedSize', choices[i] === value);
          b.setAttribute('aria-pressed', choices[i] === value ? 'true' : 'false');
          b.setAttribute('aria-label', value + (b.disabled ? ', sold out' : ''));
        });
      });
      add.disabled = selected ? !selected.available : !variants.some(v => v.available);
      const missing = options.find((o,i) => !choices[i]);
      const missingName = missing?.querySelector('legend>span')?.firstChild?.textContent?.trim().toLowerCase() || 'size';
      $('[data-add-label]').textContent = add.disabled ? 'Sold out' : selected ? 'Add to cart' : `Choose your ${missingName}`;
      $('[data-sticky-summary]').hidden = !selected;
      $('[data-sticky-add]').disabled = add.disabled || !!add.dataset.pending;
      $('[data-sticky-add]').textContent = add.dataset.pending ? 'Adding…' : add.disabled ? 'Sold out' : selected ? 'Add to cart' : `Select ${missingName}`;
      if (selected) {
        $$('[data-price]').forEach(e => { e.innerHTML = selected.price; });
        $('[data-compare]').innerHTML = selected.compare;
        $('[data-compare]').hidden = !selected.onSale;
        const sizeIndex = options.findIndex(o => o.id.startsWith('ApparelSize-'));
        $('[data-sticky-variant]').textContent = sizeIndex >= 0 ? `Size ${selected.options[sizeIndex]}` : selected.title;
        $('[data-sticky-desktop-variant]').textContent = $('[data-sticky-variant]').textContent;
      }
      const url = new URL(location.href);
      if (selected) url.searchParams.set('variant', selected.id); else url.searchParams.delete('variant');
      history.replaceState({}, '', url);
    }
    $('.enhancedOptions').hidden = false;
    $('.variantFallback').hidden = true;
    select.required = false;
    updateOptions();
    options.forEach((o,i) => o.addEventListener('click', e => {
      const b = e.target.closest('[data-option-value]');
      if (!b || b.disabled) return;
      choices[i] = b.dataset.optionValue;
      $('[data-size-status]').textContent = '';
      updateOptions();
      if (selected?.mediaId) {
        const index = panels.findIndex(p => p.dataset.mediaId === String(selected.mediaId));
        if (index >= 0) showMedia(index);
      }
    }));
    $$('[data-quantity-step]').forEach(b => b.addEventListener('click', () => {
      quantity.value = Math.max(1, (Number(quantity.value) || 1) + Number(b.dataset.quantityStep));
      quantity.dispatchEvent(new Event('change', {bubbles:true}));
    }));
    quantity.addEventListener('change', () => { quantity.value = Math.max(1, Math.floor(Number(quantity.value) || 1)); });
    form.addEventListener('submit', async e => {
      e.preventDefault();
      // This form owns its cart request; prevent the theme's AjaxProduct handler
      // from submitting the same item a second time.
      e.stopImmediatePropagation();
      if (!selected || !selected.available) {
        $('[data-form-status]').textContent = 'Please choose the available product options above.';
        options.find((o,i) => !choices[i])?.querySelector('[data-option-value]:not(:disabled)')?.focus();
        return;
      }
      if (add.dataset.pending) return;
      add.dataset.pending = 'true'; add.disabled = true;
      $('[data-sticky-add]').disabled = true;
      $('[data-sticky-add]').textContent = 'Adding…';
      $('[data-add-label]').textContent = 'Adding…';
      $('[data-form-status]').textContent = '';
      try {
        const response = await fetch((window.Shopify?.routes?.root || '/') + 'cart/add.js', {method:'POST',body:new FormData(form),headers:{'Accept':'application/json'}});
        const result = await response.json();
        if (!response.ok || result.status) throw new Error(typeof result.description === 'string' ? result.description : 'This item could not be added. Please try again.');
        $('[data-form-status]').textContent = 'Added to your cart.';
        $('[data-view-bag]').hidden = false;
        form.dispatchEvent(new CustomEvent('ajaxProduct:added', {bubbles:true,detail:{product:result,addToCartBtn:add}}));
        location.assign((window.Shopify?.routes?.root || '/') + 'cart');
      } catch (error) {
        $('[data-form-status]').textContent = error.message || 'Unable to add to cart. Please try again.';
      } finally { delete add.dataset.pending; updateOptions(); }
    }, {capture:true});
    const panels = $$('[data-media-panel]'), thumbs = $$('[data-thumb]'), stage=$('.galleryTrack');
    let active=0, gesture=null, suppressClickUntil=0;
    function syncMedia(index) {
      active=index;
      thumbs.forEach((b,i)=>{b.classList.toggle('selectedThumb',i===active);b.setAttribute('aria-pressed',String(i===active));});
      $('[data-gallery-count]').textContent=`${active+1} / ${panels.length}`;
      const rail=$('.thumbnails'), thumb=thumbs[active];
      if(thumb && rail.scrollWidth>rail.clientWidth) rail.scrollTo({left:thumb.offsetLeft-rail.offsetLeft-(rail.clientWidth-thumb.offsetWidth)/2,behavior:behavior()});
    }
    function showMedia(index) {
      const next=Math.max(0,Math.min(panels.length-1,index));
      stage.scrollTo({left:next*stage.clientWidth,behavior:behavior()});
      syncMedia(next);
    }
    thumbs.forEach(b=>b.addEventListener('click',()=>showMedia(Number(b.dataset.thumb))));
    stage.addEventListener('scroll',()=>{const index=Math.round(stage.scrollLeft/stage.clientWidth);if(index!==active)syncMedia(index);},{passive:true});
    stage.addEventListener('dragstart',e=>e.preventDefault());
    stage.addEventListener('pointerdown',e=>{
      if(!e.isPrimary || e.button!==0 || e.pointerType==='touch')return;
      gesture={x:e.clientX,start:stage.scrollLeft,id:e.pointerId,dragging:false};
    });
    stage.addEventListener('pointermove',e=>{
      if(!gesture || gesture.id!==e.pointerId)return;
      const dx=e.clientX-gesture.x;
      if(Math.abs(dx)>8){gesture.dragging=true;stage.setPointerCapture(e.pointerId);stage.classList.add('isDragging');stage.scrollLeft=gesture.start-dx;suppressClickUntil=Date.now()+400;}
    });
    const endDrag=()=>{
      if(!gesture)return;
      const dragged=gesture.dragging;gesture=null;stage.classList.remove('isDragging');
      if(dragged){suppressClickUntil=Date.now()+400;showMedia(Math.round(stage.scrollLeft/stage.clientWidth));}
    };
    stage.addEventListener('pointerup',endDrag);stage.addEventListener('pointercancel',endDrag);
    stage.addEventListener('click',e=>{if(Date.now()<suppressClickUntil){e.preventDefault();e.stopImmediatePropagation();}},true);
    $$('[data-close]').forEach(b => b.addEventListener('click', () => b.closest('dialog').close()));
    $$('dialog').forEach(d => d.addEventListener('click', e => { if (e.target === d) { const r = d.getBoundingClientRect(); if(e.clientX < r.left || e.clientX > r.right || e.clientY < r.top || e.clientY > r.bottom) d.close(); } }));
    $('[data-fit-open]').addEventListener('click', () => {
      const appChart = document.querySelector('.scr-open-size-chart');
      if (appChart && document.querySelector('.scr-modal')) appChart.click();
      else $('[data-fit-dialog]').showModal();
    });
    const strip = $('.promiseStrip');
    if (strip) {
      const track = document.createElement('div'), group = document.createElement('div');
      track.className='promiseTrack'; group.className='promiseGroup';
      while(strip.firstChild) group.appendChild(strip.firstChild);
      const separator=document.createElement('i');separator.textContent='✦';separator.setAttribute('aria-hidden','true');group.appendChild(separator);
      const copy=group.cloneNode(true);copy.setAttribute('aria-hidden','true');
      track.append(group,copy);strip.appendChild(track);
      strip.setAttribute('aria-label','Faith you can wear. Comfort you can feel. Meaning you can share.');
    }
    $$('[data-zoom]').forEach(b => b.addEventListener('click', () => { const d = $('[data-zoom-dialog]'), img = d.querySelector('img'); img.src = b.dataset.zoom; img.alt = b.querySelector('img')?.alt || ''; d.showModal(); }));
    const rail = $('.lifestyleRail');
    if (rail) {
      const cards = [...rail.children], dots = $$('[data-rail-index]');
      const step = dir => rail.scrollBy({left:dir * (cards[1] ? cards[1].offsetLeft - cards[0].offsetLeft : cards[0].offsetWidth),behavior:behavior()});
      $$('[data-rail-step]').forEach(b => b.addEventListener('click', () => step(Number(b.dataset.railStep))));
      dots.forEach((b,i) => b.addEventListener('click', () => rail.scrollTo({left:cards[i].offsetLeft - cards[0].offsetLeft,behavior:behavior()})));
      rail.addEventListener('keydown', e => { if(e.target === rail && ['ArrowLeft','ArrowRight'].includes(e.key)){e.preventDefault();step(e.key === 'ArrowRight' ? 1 : -1);} });
      function sync() {
        const end = rail.scrollLeft >= rail.scrollWidth - rail.clientWidth - 3;
        $('[data-rail-step="-1"]').disabled = rail.scrollLeft < 3;
        $('[data-rail-step="1"]').disabled = end;
        let index = end ? cards.length - 1 : cards.reduce((best,c,i) => Math.abs(c.offsetLeft - cards[0].offsetLeft - rail.scrollLeft) < Math.abs(cards[best].offsetLeft - cards[0].offsetLeft - rail.scrollLeft) ? i : best, 0);
        dots.forEach((b,i) => {b.classList.toggle('activeDot',i === index);b.setAttribute('aria-pressed',String(i === index));});
      }
      rail.addEventListener('scroll',sync,{passive:true}); sync();
    }
    $$('.ambientVideo video, .mainImage video').forEach(v => {
      let visible=false;
      v.muted=true; v.defaultMuted=true; v.loop=true; v.playsInline=true; v.controls=false;
      let hydrated=false;
      const sync=()=>{
        if(visible && !document.hidden && !reduced.matches){
          if(!hydrated){
            hydrated=true;
            if(v.dataset.src){v.src=v.dataset.src;delete v.dataset.src;}
            v.querySelectorAll('source[data-src]').forEach(source=>{source.src=source.dataset.src;delete source.dataset.src;});
            v.load();
          }
          v.play().catch(()=>{});
        }else v.pause();
      };
      const observer=new IntersectionObserver(entries=>{visible=entries[0].isIntersecting && entries[0].intersectionRatio>=.2;sync();},{threshold:[0,.2]});
      observer.observe(v);
      v.addEventListener('loadeddata',sync);
      document.addEventListener('visibilitychange',sync);reduced.addEventListener('change',sync);
    });
    const sticky = $('[data-sticky]');
    const syncSticky = () => { sticky.hidden = $('.buyRow').getBoundingClientRect().bottom > 0; };
    new IntersectionObserver(syncSticky,{threshold:0}).observe($('.buyRow'));
    window.addEventListener('scroll', syncSticky, {passive:true});
    syncSticky();
    sticky.querySelector('[data-sticky-add]').addEventListener('click', e => {
      if (selected?.available) { form.requestSubmit(); return; }
      const size = options.find((o,i) => !choices[i]) || root.querySelector('[id^="ApparelSize-"]') || $('.enhancedOptions');
      const optionName = size?.querySelector('legend>span')?.firstChild?.textContent?.trim().toLowerCase() || 'size';
      $('[data-size-status]').textContent = `Please choose a ${optionName}.`;
      if (!size) return;
      e.preventDefault();
      size.scrollIntoView({block:'start', behavior:behavior()});
      size.querySelector('[data-option-value]:not(:disabled)')?.focus({preventScroll:true});
    });
  }
  const initAll=()=>document.querySelectorAll('[data-apparel-section]').forEach(init);
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',initAll);else initAll();
  document.addEventListener('shopify:section:load',initAll);
})();
